import { z } from '@hono/zod-openapi'

// enabled
export const enabledZ = z
  .boolean()
  .openapi({ description: 'IPアドレス制限を有効にするか', example: true })
export type enabled = z.infer<typeof enabledZ>

// cidr
const IP_OR_CIDR_FORMATS = [z.ipv4(), z.ipv6(), z.cidrv4(), z.cidrv6()]

export const cidrZ = z
  .string()
  .trim()
  .min(1)
  .max(49)
  .refine(
    (value) =>
      IP_OR_CIDR_FORMATS.some((format) => format.safeParse(value).success),
    { message: 'IPアドレスまたはCIDR形式で入力してください' },
  )
  .openapi({
    description:
      '許可するIPアドレスまたはCIDR。保存時にネットワークアドレスへ正規化される',
    example: '203.0.113.0/24',
  })
export type cidr = z.infer<typeof cidrZ>

// description
export const descriptionZ = z
  .string()
  .max(255)
  .openapi({ description: '許可するIPアドレスの説明', example: '本社オフィス' })
export type description = z.infer<typeof descriptionZ>

// allowedIps
export const MAX_ALLOWED_IPS = 100

// allowedIpId
export const allowedIpIdZ = z.string().openapi({
  description: '許可IPアドレスID',
  example: '00000000-0000-4000-8000-000000000200',
})
export type allowedIpId = z.infer<typeof allowedIpIdZ>

// clientIp
export const clientIpZ = z.string().nullable().openapi({
  description: '操作者の接続元IPアドレス。取得できない場合は null',
  example: '203.0.113.42',
})
export type clientIp = z.infer<typeof clientIpZ>

// updatedBy
export const updatedByZ = z.string().nullable().openapi({
  description: '最後に設定を変更した管理者のID',
  example: 'a4f2f2e6-2d5a-4c5f-a2dd-1234567890ab',
})
export type updatedBy = z.infer<typeof updatedByZ>

// createdAt
export const createdAtStringZ = z
  .string()
  .openapi({ description: '作成日時', example: '2024-01-01T00:00:00.000Z' })
export type createdAtString = z.infer<typeof createdAtStringZ>

export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>

// updatedAt
export const updatedAtStringZ = z.string().nullable().openapi({
  description: '最終更新日時。一度も設定していない組織は null',
  example: '2024-01-01T00:00:00.000Z',
})
export type updatedAtString = z.infer<typeof updatedAtStringZ>

export const updatedAtDateZ = z
  .date()
  .nullable()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type updatedAtDate = z.infer<typeof updatedAtDateZ>
